
<template>
  <v-container fill-height container--fluid grid-list-xl>
    <v-layout wrap>
      <!--Notification Bar-->
      <v-flex md12 sm12 lg12>
        <v-alert v-if="message.show" dismissible color="green darken-3" type="info">{{message.text}}</v-alert>
      </v-flex>
      <v-flex v-if="pwdWarning" md12 sm12 lg12>
        <v-alert dismissible color="#ffdce0" type="error" icon="warning">
          <p style="color: #86181d">
            The password you provided is weak and can be easily guessed. To increase your security, please
            <v-btn text color="secondary" @click="updatePassword">update your password</v-btn>as soon as possible.
          </p>
        </v-alert>
      </v-flex>

      <!--Kobe Overview-->
      <v-flex md12 sm12 lg12 v-if="showOnDashboard('kobeOverview')">
        <kobe-overview :userRole="currentUserRole" />
      </v-flex>
      <!--Services Health-->
      <v-flex md4 sm12 xs12 v-if="showOnDashboard('servicesHealth')">
        <v-card>
          <v-toolbar color="primary">
            <v-toolbar-title class="headline">Services Health</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text icon @click="getServicesHealthData()">
              <v-icon>refresh</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <p class="subtitle-1 text-xs-right">Latest Updates : {{currentTime}}</p>
            <services-health-list :serviceList="healthCheckData" />
          </v-card-text>
        </v-card>
      </v-flex>
      <!-- Xero-->
      <v-flex md4 sm12 xs12 v-if="showOnDashboard('xero')">
        <v-card>
          <v-toolbar color="primary">
            <v-toolbar-title class="headline">Xero Dashboard</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <connect-xero></connect-xero>
          </v-card-text>
        </v-card>
      </v-flex>

      <!-- Audience Insight Preview (Temporary Disable)
      <v-flex md6 xs12 v-if="showOnDashboard('audienceInsightPreview')">
        <audience-insight-preview/>
      </v-flex>
      -->

      <!--Influencers Tasks-->
      <v-flex md4 sm12 xs12 v-if="showOnDashboard('influencerTasks')">
        <influencer-tasks />
      </v-flex>

      <!--Content Strategist Tasks-->
      <v-flex md4 sm12 xs12 v-if="showOnDashboard('csTasks')">
        <content-strategist-tasks />
      </v-flex>

      <!--Content Strategist Tasks-->
      <v-flex md4 sm12 xs12 v-if="showOnDashboard('saleTasks')">
        <sale-person-tasks />
      </v-flex>

      <!--Client Tasks-->
      <v-flex md12 sm12 xs12 v-if="showOnDashboard('clientTasks')">
        <client-tasks />
      </v-flex>

      <!--Posts Summary-->
      <v-flex md4 sm12 xs12 v-if="showOnDashboard('postsSummary')">
        <posts-summary />
      </v-flex>
      <!--Posts Summary-->
      <v-flex md4 sm12 xs12 v-if="showOnDashboard('campaignSummary')">
        <campaign-summary />
      </v-flex>
    </v-layout>
    <change-password-modal
      v-model="passwordModalDialog"
      :value="passwordModalDialog"
      @changePassword="passwordChanged"
    ></change-password-modal>
    <!-- <influencer-required-contact :dialog="showInfluencerRequiredField" :userData="userData" /> -->
  </v-container>
</template>

<script>
import api from '@/api';
import { mapState } from 'vuex';
import config from '@/config';
import moment from 'moment';
// import store from '@/store'
// import userApis from '././User/userAPIs';
// import dashboard components
import ServicesHealthList from './DashboardComponents/ServicesHealthList.vue';
import KobeOverview from './DashboardComponents/KobeOverview.vue';
import ChangePasswordModal from './User/ChangePasswordModal';
import PostsSummary from './DashboardComponents/PostsSummary.vue';
import CampaignSummary from './DashboardComponents/CampaignSummary.vue';
import InfluencerTasks from './DashboardComponents/InfluencerTasks.vue';
import ContentStrategistTasks from './DashboardComponents/ContentStrategistTasks.vue';
import SalePersonTasks from './DashboardComponents/SalePersonTasks.vue';
import ClientTasks from './DashboardComponents/ClientTasks.vue';
import ConnectXero from '../scoped/xero/ConnectXero';
import AudienceInsightPreview from './DashboardComponents/AudienceInsightPreview.vue';
// Influencer Profile Contact Required Modal
// import InfluencerRequiredContact from '././User/InfluencerProfileRequiredModal.vue';

let healthData = [];

export default {
  components: {
    ServicesHealthList,
    KobeOverview,
    ChangePasswordModal,
    CampaignSummary,
    PostsSummary,
    ConnectXero,
    InfluencerTasks,
    ContentStrategistTasks,
    SalePersonTasks,
    ClientTasks,
    AudienceInsightPreview
  },
  data() {
    return {
      passwordModalDialog: false,
      words: null,
      healthCheckData: null,
      currentTime: null,
      pwdWarning: false,
      message: {
        show: false,
        text: '',
        type: 'info'
      },
      userData: {},
      showInfluencerRequiredField: false
    };
  },
  methods: {
    logout() {
      // Dispatch event from store
      this.$store.dispatch('LOG_OUT');

      // Redirect to home page
      this.$router.push({ name: 'Login' });
    },
    passwordChanged() {
      this.passwordModalDialog = false;
      this.$swal({
        title: 'Success',
        text: 'Your password has been changed. Please login again!',
        type: 'success'
      }).then(() => {
        this.logout();
      });
    },
    updatePassword() {
      this.passwordModalDialog = true;
    },
    setupMailchimpPopup() {
      var mailchimpConfig = {
        baseUrl: 'mc.us19.list-manage.com',
        uuid: 'd509617a8b3dea7957f9fb6f4',
        lid: '59d7d5ceb3'
      };
      // No edits below this line are required
      var chimpPopupLoader = document.createElement('script');
      chimpPopupLoader.src = '//s3.amazonaws.com/downloads.mailchimp.com/js/signup-forms/popup/embed.js';
      chimpPopupLoader.setAttribute('data-dojo-config', 'usePlainJson: true, isDebug: false');
      var chimpPopup = document.createElement('script');
      chimpPopup.appendChild(
        document.createTextNode(
          'require(["mojo/signup-forms/Loader"], function (L) { L.start({"baseUrl": "' +
            mailchimpConfig.baseUrl +
            '", "uuid": "' +
            mailchimpConfig.uuid +
            '", "lid": "' +
            mailchimpConfig.lid +
            '"})});'
        )
      );
      chimpPopupLoader.onload = function() {
        document.body.appendChild(chimpPopup);
      };
      document.body.appendChild(chimpPopupLoader);
    },
    getRandomColor: function() {
      var letters = '0123456789ABCDEF';
      var color = '#';
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    getRandomRotation: function(min, max) {
      return Math.random() * (max - min) + min;
    },
    showOnDashboard(section) {
      const dashboardPermission = config['userPermissions']['dashboard'][section];
      return dashboardPermission.includes(this.user.role);
    },
    getServicesHealthData() {
      healthData = [];
      this.healthcheck('posts');
      this.healthcheck('users');
      this.healthcheck('clients');
      this.healthcheck('pairings');
      this.healthcheck('campaigns');
      this.healthcheck('companies');
      this.healthcheck('instagrams');
      this.healthcheck('influencers');
      this.healthcheck('social-data');
      this.healthcheck('content-analysis');
      this.healthcheck('payments');
      this.currentTime = moment().format('LTS');
      this.healthCheckData = healthData;
    },
    healthcheck(service) {
      let host = location.protocol + '//' + location.hostname + ':' + location.port;
      const url = host + '/api/v1/' + service + '/healthcheck';
      api
        .request('get', url, true)
        .then(res => {
          healthData.push(res.data);
        })
        .catch(() => {
          healthData.push({ service: 'Error in ' + service + '_service' });
        });
    },
    getUserProfile() {
      if (!this.influencerID || !this.currentUserID) {
        return;
      }
      // userApis.getUser(this.currentUserID)
      // .then(res => {
      //   this.userData = res
      //   if (this.userData.influencer.email == null || this.userData.influencer.email === '') {
      //     this.showInfluencerRequiredField = true
      //   } else if (this.userData.influencer.phone == null || this.userData.influencer.phone === '') {
      //     this.showInfluencerRequiredField = true
      //   } else this.showInfluencerRequiredField = false
      // })
    }
  },
  computed: {
    ...mapState(['user']),
    currentUserRole: function() {
      return this.user.role;
    },
    influencerID: function() {
      return this.user.influencerID;
    },
    currentUserID: function() {
      return this.user.id;
    }
  },
  mounted() {
    if (this.user.role === config.userRoles.ACCOUNT_MANAGER) {
      this.$router.push({name: 'am-dashboard'})
    }
    if (this.user.role === config.userRoles.AD_STRATEGIST) {
      this.$router.push({name: 'co-dashboard'})
    }
    if (this.user.role === config.userRoles.INFLUENCER) {
      this.setupMailchimpPopup();
    }
    if (this.user.role === config.userRoles.SUPER_ADMIN_HIGH) {
      this.getServicesHealthData();
    }
    this.pwdWarning = this.user.pwdWarning;

    // Retrieve user profile
    this.getUserProfile();
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// Dashboard.vue?563ebde6